import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { DataTable } from 'primereact/datatable'
import { PickList } from 'primereact/picklist'
import { InputNumber } from 'primereact/inputnumber'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { Column } from 'primereact/column'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { addScreenedFund } from '../../../actions'

import i18n from '../../../i18n.js'
import './SearchTable.css'

class SearchTable extends PureComponent {
  constructor(props) {
    super(props)
    this.assetClassFilterTemplate = this.assetClassFilterTemplate.bind(this)

    const columnsForPicklist = [
      {
        i18Name: 'ticker',
        fieldName: 'ticker',
        bodyTemplate: null,
        default: true,
        filterTemplate: null,
        dataType: 'text',
        asOfRequired: false
      },
      {
        i18Name: 'name',
        fieldName: 'name',
        bodyTemplate: null,
        default: true,
        filterTemplate: null,
        dataType: 'text',
        asOfRequired: false
      },
      {
        i18Name: 'assets-under-management',
        fieldName: 'aum',
        bodyTemplate: 'aumBodyTemplate',
        default: true,
        filterTemplate: 'aumFilterTemplate',
        dataType: 'numeric',
        asOfRequired: true
      },
      {
        i18Name: 'asset-class',
        fieldName: 'assetClass',
        bodyTemplate: null,
        default: true,
        filterTemplate: 'assetClassFilterTemplate',
        dataType: 'text',
        asOfRequired: false
      },
      {
        i18Name: 'category',
        fieldName: 'lipperCategory',
        bodyTemplate: null,
        default: true,
        filterTemplate: null,
        dataType: 'text',
        asOfRequired: false
      },
      {
        i18Name: 'region',
        fieldName: 'geoFocus',
        bodyTemplate: null,
        default: true,
        filterTemplate: null,
        dataType: 'text',
        asOfRequired: false
      },
      {
        i18Name: 'Inception Date',
        fieldName: 'inceptionDt',
        bodyTemplate: 'inceptionDateBodyTemplate',
        default: true,
        filterTemplate: 'dateFilterTemplate',
        dataType: 'date',
        asOfRequired: false
      },
      {
        i18Name: 'Net Expense Ratio',
        fieldName: 'expenseRatio',
        bodyTemplate: 'expenseRatioBodyTemplate',
        default: true,
        filterTemplate: null,
        dataType: 'numeric',
        asOfRequired: false
      },
      {
        i18Name: 'Gross Expense Ratio',
        fieldName: 'expenseRatioGross',
        bodyTemplate: 'grossExpenseRatioBodyTemplate',
        default: false,
        filterTemplate: null,
        dataType: 'numeric',
        asOfRequired: false
      }
    ]

    this.state = {
      sourceColumns: columnsForPicklist.filter(cols => cols.default === false),
      targetColumns: columnsForPicklist.filter(cols => cols.default === true),
      showColumnPicker: false
    }

    this.columnListTemplate = this.columnListTemplate.bind(this)
    this.columnListChange = this.columnListChange.bind(this)
    this.handleToggleColumnPicker = this.handleToggleColumnPicker.bind(this)
  }

  columnListTemplate(item) {
    return (
      <div className='column-list'>
        <div>{i18n.t(item.i18Name)}</div>
      </div>
    )
  }

  columnListChange(event) {
    this.setState({
      sourceColumns: event.source,
      targetColumns: event.target
    })
  }

  handleToggleColumnPicker() {
    this.setState({
      showColumnPicker: !this.state.showColumnPicker
    })
  }

  handleAddScreenedFund(fund) {
    const { name, externalID, ticker } = fund
    const id = Math.random().toString(16).substring(2)
    const rebalance_fq = 'Quarterly'
    const type = 'ticker'
    const filteredFund = { id, externalID, ticker, rebalance_fq, name, type }
    this.props.addScreenedFund(filteredFund)
  }

  renderLoading() {
    return (
      <div className='searchTableLoading row'>
        <div className={'col-sm-12'}>
          <div style={{ textAlign: 'center' }}>
            <FontAwesomeIcon icon='circle-notch' size='3x' style={{ color: '#050139' }} spin />
          </div>
        </div>
      </div>
    )
  }

  formatCurrency = value => {
    if (value) {
      return new Intl.NumberFormat(i18n.language, {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0
      }).format(value)
    } else {
      return '-'
    }
  }

  formatDate = value => {
    if (value) {
      return new Date(value).toLocaleDateString()
    }
    return ''
  }

  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }

  aumBodyTemplate = rowData => {
    return this.formatCurrency(rowData.aum)
  }

  inceptionDateBodyTemplate = rowData => {
    return this.formatDate(rowData.inceptionDate)
  }

  aumFilterTemplate(options) {
    return <InputNumber value={options.value} onChange={e => options.filterCallback(e.value, options.index)} mode='currency' currency='USD' locale='en-US' />
  }

  dateFilterTemplate(options) {
    return <Calendar value={options.value} onChange={e => options.filterCallback(e.value, options.index)} dateFormat='mm/dd/yy' placeholder='mm/dd/yyyy' mask='99/99/9999' />
  }

  expenseRatioBodyTemplate = rowData => {
    return this.formatPercent(rowData.expenseRatio)
  }

  grossExpenseRatioBodyTemplate = rowData => {
    return this.formatPercent(rowData.expenseRatioGross)
  }

  assetClassFilterTemplate(options) {
    const { searchResults } = this.props

    return <MultiSelect value={options.value} options={searchResults} onChange={e => options.filterCallback(e.value)} optionLabel='assetClass' placeholder='Any' className='p-column-filter' />
  }

  selectButtonBodyTemplate = rowData => {
    const { screenedFunds } = this.props

    const alreadyAdded = screenedFunds.filter(fund => fund.externalID === rowData.externalID)

    // IF the fund has already been selected then return null, or if there are 6 funds already selected.
    if (alreadyAdded.length > 0 || screenedFunds.length >= 6) {
      return null
    }

    return (
      <div onClick={() => this.handleAddScreenedFund(rowData)} className='add-fund'>
        <FontAwesomeIcon style={{ color: '#0FACE7' }} size='2x' icon='plus-circle' />
      </div>
    )
  }

  render() {
    const { searchResults, loading, screenedFunds } = this.props

    const { showColumnPicker, sourceColumns, targetColumns } = this.state

    if (loading) {
      return this.renderLoading()
    } else if (searchResults) {
      const asOfDate = searchResults[0].stdPerformanceMonthly ? searchResults[0].stdPerformanceMonthly[0].asOfDate : null

      const columnsToShow = targetColumns
        ? targetColumns.map((col, i) => {
            const headerClassName = col.fieldName !== 'ticker' ? 'table-header' : ''
            return <Column key={col.fieldName} field={col.fieldName} header={`${i18n.t(col.i18Name)} ${col.asOfRequired ? 'as of ' + this.formatDate(asOfDate) : ''}`} filter sortable filterPlaceholder={`Search by ${i18n.t(col.i18Name)}`} body={this[col.bodyTemplate]} filterElement={col.filterTemplate ? this[col.filterTemplate] : null} dataType={col.dataType} className={col.dataType === 'numeric' || col.dataType === 'date' ? 'alignRight' : col.fieldName === 'ticker' ? 'table-row-ticker' : 'table-row'} headerClassName={headerClassName} rowClassName={'table-row'} />
          })
        : []

      // Add the 'add' button at the beginning of the array
      columnsToShow.unshift(<Column key='add' field='add' header={i18n.t('select')} body={this.selectButtonBodyTemplate} />)

      return (
        <div className='searchTable'>
          {/* Show the column picker button */}
          {!showColumnPicker ? (
            <div className='row'>
              <div className='col-sm-12 buttonRow'>
                <button className='button' data-tip={showColumnPicker ? i18n.t('hide-column-selector') : i18n.t('show-column-selector')} aria-label={showColumnPicker ? i18n.t('hide-column-selector') : i18n.t('show-column-selector')} onClick={() => this.handleToggleColumnPicker()}>
                  <FontAwesomeIcon icon='fa-table' />
                </button>

                {/* If 6 funds have already been added then show note */}
                {screenedFunds.length >= 6 ? (
                  <div className='max-reached'>
                    <FontAwesomeIcon icon='fa-triangle-exclamation' /> {i18n.t('max-funds-reached')}
                  </div>
                ) : null}
              </div>
              <ReactTooltip className='tooltip' arrowColor='transparent' type='light' textColor='#5b6770' effect='float' />
            </div>
          ) : null}

          {/* Show the column picker */}
          {showColumnPicker ? (
            <div className='row'>
              <div className='col-sm-12 columnPickListArea'>
                <div className='row'>
                  <div className='col-sm-11 columnPickHeader'>{i18n.t('select-columns')}</div>
                  <div className='col-sm-1 columnPickClose'>
                    <button className='button' data-tip={showColumnPicker ? i18n.t('hide-column-selector') : i18n.t('show-column-selector')} aria-label={showColumnPicker ? i18n.t('hide-column-selector') : i18n.t('show-column-selector')} onClick={() => this.handleToggleColumnPicker()}>
                      <FontAwesomeIcon icon='fa-xmark' />
                    </button>
                  </div>
                  <ReactTooltip className='tooltip' arrowColor='transparent' type='light' textColor='#5b6770' effect='float' />
                </div>

                <PickList className='columnPickList' source={sourceColumns} target={targetColumns} itemTemplate={this.columnListTemplate} onChange={this.columnListChange} dataKey='fieldName' sourceFilterValue='fieldName' targetFilterValue='fieldName' showSourceControls={false} />
              </div>
            </div>
          ) : null}

          {/* Show the table with results */}
          <div className='row'>
            <div className='col-sm-12'>
              <DataTable
                value={searchResults}
                filterDisplay='menu'
                className='searchDataTable'
                paginator
                // showGridlines
                rows={10}
                // dataKey="ticker"
                // filters={ }
                // filterDisplay="menu"
                // loading={loading}
                responsiveLayout='scroll'
                // globalFilterFields={['name', 'ticker']}
                // header={ }
                // emptyMessage="No Funds found"
                tableClassName='table'
              >
                {columnsToShow}
              </DataTable>
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    searchResults: state.fundData.searchResults,
    loading: state.fundData.loadingSearchResults,
    screenedFunds: state.params.screenedFunds
  }
}

export default connect(mapStateToProps, {
  addScreenedFund
})(SearchTable)
